import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XMarkIcon, CheckCircleIcon, RocketLaunchIcon, SparklesIcon, ShieldCheckIcon } from '@heroicons/react/24/solid';

const PremiumPopup = ({ isOpen, onClose }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const features = [
        { title: "Complete Mastery", description: "Unlock all Java and Python elite mastery content.", icon: <RocketLaunchIcon className="w-5 h-5 text-yellow-400" /> },
        { title: "All Launchpad Levels", description: "Access all 5 levels for all 20 technologies.", icon: <SparklesIcon className="w-5 h-5 text-purple-400" /> },
        { title: "Premium Documents", description: "Unlimited access to all AI, AWS, and React documentation.", icon: <ShieldCheckIcon className="w-5 h-5 text-blue-400" /> },
        { title: "90+ Technologies", description: "Practice MCQs across 90+ advanced technologies.", icon: <CheckCircleIcon className="w-5 h-5 text-green-400" /> }
    ];

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="relative w-full max-w-lg bg-[#111827] border border-gray-800 rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
                {/* Header Gradient */}
                <div className="absolute top-0 inset-x-0 h-2 bg-gradient-to-r from-purple-600 via-blue-500 to-emerald-500"></div>
                
                <button 
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-full transition-colors z-10"
                >
                    <XMarkIcon className="w-6 h-6" />
                </button>

                <div className="p-8">
                    <div className="text-center mb-8">
                        <div className="inline-block p-3 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-2xl border border-purple-500/30 mb-4">
                            <SparklesIcon className="w-8 h-8 text-purple-400" />
                        </div>
                        <h2 className="text-3xl font-bold text-white mb-2">Upgrade to Premium</h2>
                        <p className="text-gray-400">Unlock your full potential with Enterprise-grade learning tools.</p>
                    </div>

                    <div className="space-y-4 mb-10">
                        {features.map((feature, idx) => (
                            <div key={idx} className="flex items-start gap-4 p-4 bg-white/5 rounded-2xl border border-white/5 hover:border-purple-500/30 transition-colors">
                                <div className="p-2 bg-white/5 rounded-lg">
                                    {feature.icon}
                                </div>
                                <div>
                                    <h4 className="font-bold text-white text-sm">{feature.title}</h4>
                                    <p className="text-gray-400 text-xs">{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <button 
                            onClick={onClose}
                            className="px-6 py-4 bg-white/5 hover:bg-white/10 text-white font-bold rounded-2xl transition-all"
                        >
                            Maybe Later
                        </button>
                        <button 
                            onClick={() => {
                                onClose();
                                navigate('/subscription-plans');
                            }}
                            className="px-6 py-4 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-bold rounded-2xl shadow-lg shadow-purple-600/20 transition-all transform hover:scale-[1.02] active:scale-[0.98]"
                        >
                            Upgrade Now
                        </button>
                    </div>

                    <p className="mt-6 text-center text-xs text-gray-500">
                        Starting from just ₹299. No hidden charges.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PremiumPopup;
